import { motion } from 'framer-motion';
import { FaGithub, FaLinkedinIn, FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';
import { HiArrowUp } from 'react-icons/hi';
import { PERSON } from '../data';

const SOCIALS = [
  { Icon:FaGithub,        href:PERSON.github,   label:'GitHub'   },
  { Icon:FaLinkedinIn,    href:PERSON.linkedin, label:'LinkedIn' },
  { Icon:FaTelegramPlane, href:PERSON.telegram, label:'Telegram' },
  { Icon:FaWhatsapp,      href:PERSON.whatsapp, label:'WhatsApp' },
];

const LINKS = [
  { href:'#about',      l:'About'      },
  { href:'#skills',     l:'Skills'     },
  { href:'#experience', l:'Experience' },
  { href:'#projects',   l:'Projects'   },
  { href:'#services',   l:'Services'   },
  { href:'#contact',    l:'Contact'    },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.05] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-t from-[#04040a] to-transparent pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 py-14 relative z-10">

        <div className="grid sm:grid-cols-3 gap-10 mb-12">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-violet-600 to-indigo-600 flex items-center justify-center font-mono font-bold text-sm text-white">MK</div>
              <span className="font-bold text-white text-[17px]">Mustafa<span className="grad-text">.dev</span></span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed mb-6">
              Senior Full-Stack Developer crafting enterprise-grade web applications with React & Laravel.
            </p>
            <div className="flex gap-3">
              {SOCIALS.map(({ Icon, href, label }) => (
                <motion.a key={label} href={href} target="_blank" rel="noopener noreferrer"
                  whileHover={{scale:1.15,y:-2}}
                  className="w-9 h-9 rounded-lg glass border border-white/[0.06] hover:border-violet-500/40 flex items-center justify-center text-slate-500 hover:text-violet-400 transition-all"
                ><Icon size={13}/></motion.a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm">Quick Links</h4>
            <ul className="space-y-3">
              {LINKS.map(({ href, l }) => (
                <li key={href}>
                  <a href={href} className="text-slate-500 hover:text-violet-400 text-sm transition-colors flex items-center gap-2 group">
                    <span className="text-violet-700 group-hover:translate-x-1 transition-transform text-xs">▸</span>{l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm">Contact</h4>
            <div className="space-y-3 text-slate-500 text-sm">
              <p>📍 {PERSON.location}</p>
              <p>✉️ {PERSON.email}</p>
              <p>📱 +251 927505142</p>
              <div className="flex items-center gap-2 pt-2">
                <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"/>
                <span className="text-green-400 text-xs font-medium">Available for projects</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div className="border-t border-white/[0.05] pt-7 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-600 text-sm">© {new Date().getFullYear()} Mustafa Kadir Hasan · Built with ⚛️ React & 💜 passion</p>
          <motion.button onClick={()=>window.scrollTo({top:0,behavior:'smooth'})}
            whileHover={{scale:1.1,y:-2}} whileTap={{scale:0.95}}
            className="w-10 h-10 rounded-xl glass border border-violet-500/20 hover:border-violet-500/60 flex items-center justify-center text-violet-400 hover:text-violet-300 transition-all neon-v"
          ><HiArrowUp size={17}/></motion.button>
        </div>
      </div>
    </footer>
  );
}
